import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';

import PropTypes from 'prop-types';
import React from 'react';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

const colDefs = [
    {
        field: 'orderNumber',
        headerName: 'OrderNumber',
        sortable: true,
        filter: true,
        width: 200
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        filter: true,
        width: 498
    }
];

const RepingTable = props => (

    <section className="atp-search-result-panel reping-result-panel">

        <div className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
            <AgGridReactComponent
                reactNext={true}
                columnDefs={colDefs}
                rowData={props.results}
                onGridReady={onGridReady}
            />

        </div>

    </section>
);

RepingTable.propTypes = {
    results: PropTypes.array.isRequired
};
export default RepingTable;
